import { FC } from 'react';
import { GridFilterItem } from '../common/grid/GridFilterItem';
import { entryRequestListActions, EntryRequestListFilter } from '../../store/entities/entryRequestList';
import { GridFilterApprovalState } from '../common/grid/GridFilterApprovalState';
import { GridFilterSupplierMultiple } from '../common/grid/GridFilterSupplierMultiple';
import { GridFilterInvitationMultiple } from '../common/grid/GridFilterInvitationMultiple';
import { GridFilterDateFromTo } from '../common/grid/GridFilterDateFromTo';
import { MultipleEmployeeWrapper } from '../common/grid/GridFilterEmployee';
import { isExternal } from '../../utils/roles';
import { selectIdentity } from '../../store/entities/identity';
import { useAppSelector } from '../../store';

interface Props {
  query: EntryRequestListFilter;
}

export const EntryRequestFilter: FC<Props> = ({ query }) => {
  const identity = useAppSelector(selectIdentity);
  return (
    <>
      {!isExternal(identity) && (
        <>
          <GridFilterItem
            query={query}
            gridActions={entryRequestListActions}
            name="supplier"
            title="invitation.entryRequest.table.supplier"
            disableAutoClose={true}
            Component={GridFilterSupplierMultiple}
          />
          <GridFilterItem
            query={query}
            gridActions={entryRequestListActions}
            name="invitation"
            title="invitation.entryRequest.table.invitation"
            disableAutoClose={true}
            Component={GridFilterInvitationMultiple}
          />
        </>
      )}
      <GridFilterItem
        query={query}
        gridActions={entryRequestListActions}
        name="dateRange"
        title="invitation.entryRequest.table.date"
        disableAutoClose={true}
        Component={GridFilterDateFromTo}
      />
      {!isExternal(identity) && (
        <GridFilterItem
          query={query}
          gridActions={entryRequestListActions}
          name="responsiblePersonCompany"
          title="invitation.employee"
          disableAutoClose={true}
          Component={MultipleEmployeeWrapper}
        />
      )}
      <GridFilterItem
        disableAutoClose={true}
        query={query}
        gridActions={entryRequestListActions}
        name="state"
        title="training.state"
        Component={GridFilterApprovalState}
      />
    </>
  );
};
